import { createContext, useContext, useState } from "react";
import { useFetch } from "../lib/useFetch";

const FilterContext = createContext(null);

export function FilterProvider({ children }) {
  const [range, setRange] = useState("last_30_days");
  const [hub, setHub] = useState("all");
  const { data: hubs } = useFetch("/meta/hubs", []);
  return (
    <FilterContext.Provider value={{ range, setRange, hub, setHub, hubs: hubs || [] }}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilters = () => useContext(FilterContext);
